var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('vs-avatar',{staticClass:"flex-shrink-0 mr-2",attrs:{"src":_vm.params.data.avatar,"size":"80px"},on:{"click":function($event){return _vm.$router.push(_vm.url)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }